import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { endpoints, ID } from '@rossum/api-client';
import { notify } from '../../features/toaster';
import { api } from '../../lib/apiClient';
import { removeQueueMutation } from './removeQueueMutation';
import { QUERY_KEY_LAZY_QUEUES } from './useLazyQueues';

export const useDeleteQueue = (onSuccess: (queueId: number) => void) => {
  const intl = useIntl();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (queueId: ID) => api.request(endpoints.queues.delete(queueId)),

    onSuccess: (_, queueId) => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_LAZY_QUEUES],
      });

      // remove queue from the list of queues
      removeQueueMutation(queryClient, queueId);
      notify.default({
        title: intl.formatMessage({
          id: 'containers.message.queueDeleted',
        }),
      });
      onSuccess(queueId);
    },
  });
};
